import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "nxtconstants";

const MFDistributor = ({ distributorData = {} }) => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <Card>
      <Left>
        <Heading>
          {distributorData.heading.line1}
          <br />
          <span>{distributorData.heading.highlight}</span>
        </Heading>
        <Description>
          {distributorData.description}
        </Description>
        <ButtonSection>
          <CTAButton href="#register">
            {distributorData.ctaText}
          </CTAButton>
        </ButtonSection>
      </Left>

      <ImageWrapper>
        <Image
          src={distributorData.image}
          alt="Sales Kit Image"
          width={900}
          height={840}
          loading="lazy"
          decoding="async"
        />
        <PlayButton onClick={() => setShowVideo(true)}>
          Sales Kit
          <img
            src={distributorData.playIcon}
            alt="Play Icon"
            width={24}
            height={24}
            decoding="async"
          />
        </PlayButton>
      </ImageWrapper>

      {showVideo && (
        <VideoModal>
          <VideoContent>
            <CloseButton onClick={() => setShowVideo(false)}>X</CloseButton>
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${distributorData.videoId}`}
              title="Sales Kit Video"
              style={{ border: 0, width: "100%", height: "400px" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </VideoContent>
        </VideoModal>
      )}
    </Card>
  );
};

const Card = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8rem;
  border-radius: 1.5rem;
  background: #F7F9FF;
  gap: 4rem;
  margin: 10rem auto;
  width: 85%;
  max-width: 125rem; 

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    margin: 8rem auto 5rem;
    width:100%;
    border-radius: 0;
    padding: 4rem 4rem; 
    gap: 3rem;
  }
`;

const Left = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    order: 1; 
  }
`;

const ButtonSection = styled.div``;

const CTAButton = styled.a`
  display: inline-block;
  font-family: 'Lato';
  text-align: center;
  margin-top: 3.2rem;
  padding: 1rem 8rem;
  font-size: 2rem;
  font-weight: 700;
  color: ${colors.white};
  background: ${colors.primary};
  border-radius: 3rem; 
  text-decoration: none;

  @media (max-width: 768px) {
    margin-top: 2rem;
    padding: 1rem 10rem;
    font-size: 1.6rem;
    border-radius: 2.8rem; 
    text-align: center;
  }
`;

const Heading = styled.h2`
  font-size: 4.2rem;
  font-weight: 400;
  font-family: "DM Serif Display";
  line-height: 1.4;
  margin-bottom: 2rem;
  color: ${colors.textBlack};

  @media (max-width: 768px) {
    font-size: 2.8rem; 
    text-align: left;
  }

  span {
    color: ${colors.primary};
  }
`;

const Description = styled.p`
  font-size: 2.4rem;
  font-family: "Lato";
  font-weight: 700;
  margin-bottom: 2rem;
  color: ${colors.textBlack};

  @media (max-width: 768px) {
    font-size: 1.8rem;
    text-align: left;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 45rem;
  height: 42rem;
  display: inline-block;

  @media (max-width: 768px) {
    width: 100%;
    height: auto; 
    order: 2; 
  }
`;

const Image = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== "theme"
})`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2rem;

  @media (max-width: 768px) {
    height: auto;
  }
`;

const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${colors.white};
  color: ${colors.black}; 
  font-size: 1.6rem;
  padding: 0.8rem 1.6rem;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.8rem; 
`;

const VideoModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const VideoContent = styled.div`
  background: ${colors.white};
  padding: 1rem;
  border-radius: 1rem;
  width: 90%;
  max-width: 80rem;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: ${colors.white};
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
`;
export default MFDistributor;